// client/src/App.js

import {
  AlertDialog,
  AlertDialogBody, AlertDialogContent, AlertDialogFooter,
  AlertDialogHeader, AlertDialogOverlay, Button,
  Center,
  Flex,
  FormControl,
  FormLabel,
  IconButton,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Tfoot,
  Th,
  Thead,
  Tr,
  useToast
} from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { AiFillStepBackward, AiFillStepForward } from "react-icons/ai";
import { FaSortDown, FaSortUp } from "react-icons/fa";
import { MdAdd, MdDelete, MdEdit } from "react-icons/md";
import "../../App.css";
import CommonContext from '../../commonContext';
import { postCall } from '../../utils/requests';
import Utils from '../../utils/utils';

function PodcastList() {

  /* TODO const navigate = useNavigate(); */
  const commonContext = React.useContext(CommonContext);

  const logout = () => {
    console.log("logout")
    localStorage.removeItem("accessToken");
    /* TODO navigate('/'); */
  }

  /* utils */
  const toast = useToast();
  const fileRef = React.useRef(null);

  /* table */
  const [tableContent, setTableContent] = useState([]);
  const [allData, setAllData] = useState([]);

  /* delete form */
  const [isOpenDelete, setIsOpenDelete] = React.useState(false)
  const [isOpenCreate, setIsOpenCreate] = React.useState(false)
  const [isOpenEdit, setIsOpenEdit] = React.useState(false)
  const [idToDelete, setIdToDelete] = React.useState(null)
  const [idToUpdate, setIdToUpdate] = React.useState(null)
  const [nameToDelete, setNameToDelete] = React.useState("")
  const [page, setPage] = React.useState(1)
  const [search, setSearch] = React.useState("")
  const [sortOrder, setSortOrder] = React.useState("desc")
  const [sortedBy, setSortedBy] = React.useState("")

  const [description, setDescription] = React.useState([])
  const [year, setYear] = React.useState("")
  const [position, setPosition] = React.useState("")
  const [competitionTime, setCompetitionTime] = React.useState("")

  const fetchPalmares = async () => {


    postCall("/fetchPalmares", {}).then((data) => {

      console.log(data)


      setAllData(Array.from(data.data.map((item) => {

        return {
          id: item.id_palmares,
          description: item.description,
          year: item.year,
          position: item.position,
          competition_time: item.competition_time,
          created_at: Utils.convertDateToIta(item.created_at, true),
          creation_date: item.created_at
        }
      })));

      /* put in tableContent only first n element from allData */
      setTableContent(Array.from(data.data.map((item) => {


        return {
          id: item.id_palmares,
          description: item.description,
          year: item.year,
          position: item.position,
          competition_time: item.competition_time,
          created_at: Utils.convertDateToIta(item.created_at, true),
          creation_date: item.created_at
        }
      })).slice((page * 7) - 7, (page * 7)));

    });
  }

  useEffect(() => {

    fetchPalmares()

    commonContext.setCurrentPath("Palmares")
    commonContext.setCurrentPage("palmares")

  }, []);



  /* BEGIN - EDIT FORM */

  const handleSubmitEdit = async (event) => {
    event.preventDefault();
    if (description === "") {
      toast({
        title: "Errore",
        description: "Inserisci una descrizione per il risultato",
        status: "error",
        duration: 2000,
        isClosable: true,
        position: "top"
      })
      return
    }

    postCall("/updatePalmares", {
      description: description,
      id_palmares: idToUpdate,
      year: year,
      position: position,
      competition_time: competitionTime,
    }).then((data) => {
      if (data.status === "success") {

        fetchPalmares()
        setDescription("")
        setYear("")
        setPosition("")
        setCompetitionTime("")
        setIdToUpdate(null)

        toast({
          title: "Perfetto",
          description: "Risultato modificato",
          status: "success",
          duration: 2000,
          isClosable: true,
          position: "top"
        })
        onCloseEdit()

      } else {

        toast({
          title: "Errore",
          description: data.error === "15" ? "Questo nome esiste già" : "Si è verificato un errore",
          status: "error",
          duration: 2000,
          isClosable: true,
          position: "top"
        })
      }

    });

  }

  const onCloseEdit = async () => {
    setIsOpenEdit(false)
  }

  const openEdit = async (id, description, year, position, competition_time) => {
    setIdToUpdate(id);
    setDescription(description)
    setYear(year)
    setPosition(position)
    setCompetitionTime(competition_time)

    setIsOpenEdit(true)
  }
  /* END - EDIT FORM */


  /* BEGIN - CREATE FORM */

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (description === "" || description === null || description === undefined) {
      toast({
        title: "Errore",
        description: "Inserisci una descrizione",
        status: "error",
        duration: 2000,
        isClosable: true,
        position: "top"
      })
      return
    }

    postCall("/createPalmares", {
      description: description,
      year: year,
      position: position,
      competition_time: competitionTime,
    }).then((data) => {
      if (data.status === "success") {

        fetchPalmares()
        setDescription("")
        setYear("")
        setPosition("")
        setCompetitionTime("")

        toast({
          title: "Perfetto",
          description: "Risultato aggiunto",
          status: "success",
          duration: 2000,
          isClosable: true,
          position: "top"
        })

        onCloseCreate()

      } else {


        toast({
          title: "Errore",
          description: data.error === "15" ? "Questa nome esiste già" : "Si è verificato un errore",
          status: "error",
          duration: 2000,
          isClosable: true,
          position: "top"
        })
      }

    });

  }

  const onCloseCreate = async () => {
    setIsOpenCreate(false)
  }

  const openCreate = async (id, name) => {
    console.log("openCreate")
    setDescription("")
    setYear("")
    setPosition("")
    setCompetitionTime("")
    setIsOpenCreate(true)
  }
  /* END - CREATE FORM */


  /* BEGIN - DELETE FORM */
  const deleteCategory = async () => {
    console.log("onCloseDelete")


    setIsOpenDelete(false)
    postCall("/deletePalmares", {
      id_palmares: idToDelete
    }).then((data) => {
      if (data.status === "success") {

        /* remove the deleted category from the list */
        setTableContent(tableContent.filter((item) => item.id !== idToDelete))
        setIdToDelete(null)
        setNameToDelete("")

        toast({
          title: "Perfetto",
          description: "Risultato eliminato",
          status: "success",
          duration: 2000,
          isClosable: true,
          position: "top"
        })
        fetchPalmares()
      } else {
        toast({
          title: "Errore",
          description: "Si è verificato un errore",
          status: "error",
          duration: 2000,
          isClosable: true,
          position: "top"
        })
      }

    });
  }

  const onCloseDelete = async () => {
    setIsOpenDelete(false)
  }

  const openDelete = async (id, name) => {
    console.log("openDelete")
    setIdToDelete(id)
    setNameToDelete(name)
    setIsOpenDelete(true)
  }
  /* END - DELETE FORM */

  /* BEGIN - SORTABLE */

  const handleSortYear = () => {
    setSortedBy("year")
    let allDataSorted = []

    if (sortOrder === 'asc') {
      // Sort in ascending order
      allDataSorted = [...allData].sort((a, b) => a.year.localeCompare(b.year))
      setAllData(allDataSorted);

      setSortOrder('desc');
    } else {
      // Sort in descending order
      allDataSorted = [...allData].sort((a, b) => b.year.localeCompare(a.year));
      setAllData(allDataSorted);

      setSortOrder('asc');
    }

    setTableContent(Array.from(allDataSorted.map((item) => {
      return {
        id: item.id,
        description: item.description,
        year: item.year,
        position: item.position,
        competition_time: item.competition_time,
        created_at: Utils.convertDateToIta(item.created_at, true),
        creation_date: item.created_at


      }
    })).slice((page * 7) - 7, (page * 7)));
  };

  const handleSortCreated = () => {
    setSortedBy("created")

    let allDataSorted = []

    if (sortOrder === 'asc') {
      // Sort in ascending order
      allDataSorted = [...allData].sort((a, b) => a.creation_date.localeCompare(b.creation_date))
      setAllData(allDataSorted);

      setSortOrder('desc');
    } else {
      // Sort in descending order
      allDataSorted = [...allData].sort((a, b) => b.creation_date.localeCompare(a.creation_date));
      setAllData(allDataSorted);

      setSortOrder('asc');
    }

    setTableContent(Array.from(allDataSorted.map((item) => {

      return {
        id: item.id,
        description: item.description,
        year: item.year,
        position: item.position,
        competition_time: item.competition_time,
        created_at: Utils.convertDateToIta(item.created_at, true),
        creation_date: item.created_at
      }
    })).slice((page * 7) - 7, (page * 7)));
  };

  const handleSortDescription = () => {
    setSortedBy("description")

    let allDataSorted = []

    if (sortOrder === 'asc') {
      // Sort in ascending order
      allDataSorted = [...allData].sort((a, b) => a.description.localeCompare(b.description))
      setAllData(allDataSorted);

      setSortOrder('desc');
    } else {
      // Sort in descending order
      allDataSorted = [...allData].sort((a, b) => b.description.localeCompare(a.description));
      setAllData(allDataSorted);

      setSortOrder('asc');
    }

    setTableContent(Array.from(allDataSorted.map((item) => {

      return {
        id: item.id,
        description: item.description,
        year: item.year,
        position: item.position,
        competition_time: item.competition_time,
        created_at: Utils.convertDateToIta(item.created_at, true),
        creation_date: item.created_at


      }
    })).slice((page * 7) - 7, (page * 7)));
  };

  /* END - SORTABLE */



  return (
    <div style={{ "width": "100%", textAlign: "center", height: "100%", overflowY: "scroll" }}>
      {/* BEGIN - FORM TO EDIT A NEW CATEGORY */}
      <Modal isOpen={isOpenEdit} onClose={onCloseEdit}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Modifica Risultato</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <form onSubmit={handleSubmit}>
              <FormControl id="categoryName">
                <FormLabel>Descrizione</FormLabel>
                <Input
                  mb="20px"
                  type="text"
                  value={description}
                  onChange={(event) => setDescription(event.target.value)}
                />
                <FormLabel>Anno</FormLabel>
                <Input
                  mb="20px"
                  type="text"
                  value={year}
                  onChange={(event) => setYear(event.target.value)}
                />
                <FormLabel>Posizione</FormLabel>
                <Input
                  mb="20px"
                  type="text"
                  value={position}
                  onChange={(event) => setPosition(event.target.value)}
                />
                <FormLabel>Tempo</FormLabel>
                <Input
                  mb="20px"
                  type="text"
                  value={competitionTime}
                  onChange={(event) => setCompetitionTime(event.target.value)}
                />

              </FormControl>
            </form>
          </ModalBody>
          <ModalFooter>
            <Button onClick={onCloseEdit} mr={3}>Indietro</Button>
            <Button type="submit" colorScheme="green" onClick={handleSubmitEdit}>Modifica risultato</Button>

          </ModalFooter>
        </ModalContent>
      </Modal>
      {/* END - FORM TO EDIT A NEW CATEGORY */}

      {/* BEGIN - FORM TO CREATE A NEW CATEGORY */}
      <Modal isOpen={isOpenCreate} onClose={onCloseCreate}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Registra un nuovo risultato</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <form onSubmit={handleSubmit}>
              <FormControl id="categoryName">
                <FormLabel>Descrizione</FormLabel>
                <Input
                  mb="20px"
                  type="text"
                  value={description}
                  onChange={(event) => setDescription(event.target.value)}
                />
                <FormLabel>Anno</FormLabel>
                <Input
                  mb="20px"
                  type="text"
                  value={year}
                  onChange={(event) => setYear(event.target.value)}
                />
                <FormLabel>Posizione</FormLabel>
                <Input
                  mb="20px"
                  type="text"
                  value={position}
                  onChange={(event) => setPosition(event.target.value)}
                />
                <FormLabel>Tempo</FormLabel>
                <Input
                  mb="20px"
                  type="text"
                  value={competitionTime}
                  onChange={(event) => setCompetitionTime(event.target.value)}
                />

              </FormControl>
            </form>
          </ModalBody>
          <ModalFooter>
            <Button onClick={onCloseCreate} mr={3}>Indietro</Button>
            <Button type="submit" colorScheme="green" onClick={handleSubmit}>Aggiungi risultato</Button>

          </ModalFooter>
        </ModalContent>
      </Modal>
      {/* END - FORM TO CREATE A NEW CATEGORY */}

      {/* BEGIN - BACK BUTTON */}
      {/* <Stack mt="5" ml="2" mb="5" mr="15" direction='row' spacing={4}>
        <Center><IconButton
          isRound={true}
          variant='solid'
          colorScheme='teal'
          aria-label='Done'
          fontSize='20px'
          icon={<IoMdArrowRoundBack />}
        /></Center>
        <Box w="5%"></Box>
        <Center >
          <Text
            fontSize="4xl"
            as="b"
            color="teal">
            {commonContext.currentPath}
          </Text>
        </Center>
      </Stack> */}
      {/* END - BACK BUTTON */}

      <hr></hr>

      {/* BEGIN - TOP ROW */}
      <Stack pr="20px" mt="2%" ml="2" mb="10" direction='row' spacing={4} justifyContent="space-between">
        <Flex justifyContent="left" w="100%" >
          <Button mr="20px" leftIcon={<MdAdd />} colorScheme='green' variant='solid' onClick={openCreate}>
            Nuovo risultato
          </Button>
          {/*  <Link to="/sortCategories">
            <Button leftIcon={<BsSortUp />} colorScheme='orange' variant='solid' >
              Modifica ordine
            </Button>
          </Link> */}
        </Flex>
        <Flex justifyContent="right" w="100%" >

          <Input
            borderColor="black"
            w="30%"
            placeholder="Cerca..."
            type="text"
            value={search}
            onChange={(event) => {
              setSearch(event.target.value)

              if (event.target.value === "") {
                setTableContent(allData.slice((page * 7) - 7, (page * 7)));
              } else {
                setTableContent(allData.filter((item) => item.description.toLowerCase().includes(event.target.value.toLowerCase()) && item.description.toLowerCase().includes(search.toLowerCase())));
              }

            }}
          />
        </Flex>
      </Stack>
      {/* END - TOP ROW */}

      {/* BEGIN - DELETE FROM */}
      <AlertDialog
        isOpen={isOpenDelete}
        onClose={onCloseDelete}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize='lg' fontWeight='bold'>
              Elimina categoria
            </AlertDialogHeader>

            <AlertDialogBody>
              Vuoi eliminare definitivamente il risultato "{nameToDelete}"?
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button onClick={onCloseDelete}>
                Indietro
              </Button>
              <Button colorScheme='red' onClick={deleteCategory} ml={3}>
                Elimina
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
      {/* END - DELETE FORM */}
      {allData.length < 1 && <Flex h="300px" alignItems="center" justifyContent="center">
        <Text fontSize="xl" as="b" color="teal">Nessuna categoria</Text>
      </Flex>}
      {/* BEGIN - TABLE */}
      {allData.length > 0 && <TableContainer h="100%" >
        <Table variant='striped' colorScheme='blue' w="100%" sx={{ tableLayout: "fixed" }}>
          {/* <TableCaption>Elenco delle categorie</TableCaption> */}
          <Thead>
            <Tr>
              <Th w="5%">ID</Th>
              <Th _hover={{ cursor: "pointer" }} onClick={handleSortDescription}><Flex align="center" >Descrizione{sortedBy === "description" && sortOrder === "asc" && <FaSortDown />} {sortedBy === "description" && sortOrder === "desc" && <FaSortUp />}</Flex></Th>
              <Th w="8%" _hover={{ cursor: "pointer" }} onClick={handleSortYear}><Flex align="center">Anno{sortedBy === "year" && sortOrder === "asc" && <FaSortDown />} {sortedBy === "year" && sortOrder === "desc" && <FaSortUp />}</Flex></Th>
              <Th w="8%">Posizione</Th>
              <Th w="8%">Tempo</Th>
              <Th _hover={{ cursor: "pointer" }} onClick={handleSortCreated} w="15%"><Flex align="center">Creata il {sortedBy === "created" && sortOrder === "asc" && <FaSortDown />} {sortedBy === "created" && sortOrder === "desc" && <FaSortUp />}</Flex></Th>
              <Th w="8%"></Th>
            </Tr>
          </Thead>
          <Tbody>
            {tableContent.map((item) => (

              <Tr key={item.id}>
                <Td>{item.id}</Td>
                <Td title={item.description} overflowX="hidden" overflow="hidden" textOverflow="ellipsis">{item.description}</Td>
                <Td title={item.year} overflowX="hidden" overflow="hidden" textOverflow="ellipsis">{item.year}</Td>
                <Td title={item.position} overflowX="hidden" overflow="hidden" textOverflow="ellipsis">{item.position}</Td>
                <Td title={item.competition_time} overflowX="hidden" overflow="hidden" textOverflow="ellipsis">{item.competition_time}</Td>

                <Td>{item.created_at}</Td>
                <Td><IconButton
                  mr="2"
                  colorScheme='red'
                  aria-label='Call Segun'
                  size='sm'
                  icon={<MdDelete />}
                  onClick={() => { openDelete(item.id, item.description) }}
                />
                  <IconButton
                    mr="2"
                    colorScheme='orange'
                    aria-label='Call Segun'
                    size='sm'
                    icon={<MdEdit />}
                    onClick={() => {
                      openEdit(item.id, item.description, item.year, item.position, item.competition_time)
                    }}
                  /></Td>
              </Tr>
            ))}

          </Tbody>
          <Tfoot>
            <Tr>
              <Th w="5%">ID</Th>
              <Th _hover={{ cursor: "pointer" }} onClick={handleSortDescription}><Flex align="center" >Descrizione{sortedBy === "name" && sortOrder === "asc" && <FaSortDown />} {sortedBy === "name" && sortOrder === "desc" && <FaSortUp />}</Flex></Th>
              <Th w="8%" _hover={{ cursor: "pointer" }} onClick={handleSortYear}><Flex align="center">Anno{sortedBy === "father" && sortOrder === "asc" && <FaSortDown />} {sortedBy === "father" && sortOrder === "desc" && <FaSortUp />}</Flex></Th>
              <Th w="8%">Posizione</Th>
              <Th w="8%">Tempo</Th>
              <Th _hover={{ cursor: "pointer" }} onClick={handleSortCreated} w="15%"><Flex align="center">Creata il {sortedBy === "created" && sortOrder === "asc" && <FaSortDown />} {sortedBy === "created" && sortOrder === "desc" && <FaSortUp />}</Flex></Th>
              <Th w="8%"></Th>
            </Tr>

          </Tfoot>
        </Table>
      </TableContainer>}


      {search === "" && <Center w="100%" mb="4">
        <IconButton
          isRound={true}
          variant='solid'
          colorScheme='teal'
          aria-label='Done'
          fontSize='20px'
          onClick={() => {
            if (page > 1) {
              setTableContent(allData.slice((page * 7) - 14, (page * 7) - 7));
              setPage(page - 1);
            }
          }}
          icon={<AiFillStepBackward />}
        />
        <Text ml="4" mr="4">
          {page} / {Math.ceil(allData.length / 7)}
        </Text>
        <IconButton
          isRound={true}
          variant='solid'
          colorScheme='teal'
          aria-label='Done'
          fontSize='20px'
          onClick={() => {
            if (page < Math.ceil(allData.length / 7)) {
              setTableContent(allData.slice((page * 7), (page * 7) + 7));
              setPage(page + 1);
            }
          }}
          icon={<AiFillStepForward />}
        />
      </Center>}

      {/* END - TABLE */}
    </div>

  );

}

export default PodcastList;